<template>
  <div class="AuxOutput">
    <div class="output-item">
        <div class="title">{{$t('lang.LiveSource')}}</div>
        <public-multiple-select
        v-if="LiveParams"
        :disabled="outputParams.isStart"
        :SelectType="2"
        :configParams="LiveParams"
        :SelectValue="{
            fileId: auxOutput.sourceId,
            fileName: auxOutput.fileName,
        }"
        :SearchTypeList="[true, false, false]"
        :otherParam="{placeholder: 'select',hierarchy: 99}"
        @MediaLiveSelectChange="pitchOnFile => SubeventFileDispose(pitchOnFile)"
        @clearMessage="SubeventClearMessage()"
        >
        </public-multiple-select>
    </div>
    <div class="output-item">
        <div class="title">{{$t('lang.Output')}}</div>
        <Output
        v-if="occasionalOutputMessage"
        :disabled="outputParams.isStart"
        from="selectList"
        :otherParam="otherParam"
        :ProgramItem="ProgramItem"
        @AccountSelectInfo="AccountSelectInfo"
        :selectedAccount="auxOutput.output"
        ></Output>
    </div>
    <div class="video">
        <div :style="StyleMessage" class="blackOutput" v-if="!resetOutput"></div>
        <video-module
            v-else
            :height="StyleMessage.height"
            :width="StyleMessage.width"
            :source="liveData"
            deviceType="T"
            :rid="liveData.livePeerId"
            :oldReceiverInfoObj="liveData"
            :oldGetKernelStateObj="liveData"
            :useOldR="false"
            :sid="liveData.peerId"
            :status="liveData.status"
          />
    </div>
    <div class="button">
        <el-button type="success" v-if="!outputParams.isStart" :disabled="CloneDisabled.disableButton" @click="startOutput" :loading="outputLoading">{{$t('lang.start') }}</el-button>
        <el-button type="danger" v-else @click="stopOutput" :loading="outputLoading">{{$t('lang.StopOutput')}} ({{outputParams.time }})</el-button>
    </div>
    <div class="outputHistoryList">
        <div class="outputHistory" v-for="item in OutputHistoryList" :key="item.id" >
            <div class="left">
              <div class="name">{{ item.sourceName }} - {{ item.outputName }}</div>
              <div class="time">
                {{ displayTime(item.startTime) }}
              </div>
            </div>
            <div class="right">
              {{ calculateInterval(item.duration) }}
            </div>
        </div>
    </div>
    <div class="totalDuration">{{ $t('lang.totalDuration') }}{{totalDuration?calculateInterval(totalDuration):totalDuration }}</div>
  </div>
</template>

<script>
import Outil from '@/assets/js/utils.js'
import { SourceConfigParams } from '@/assets/js/temConfig.js'
import PublicMultipleSelect from '@/components/select/PublicMultipleSelect.vue'
import Output from '@/views/Workbench/Output.vue'
import videoModule from '@/components/common/VideoC'
import { mapState } from 'vuex'
import Bus from '@/assets/js/vueBus.js'
import toTips from '@/assets/js/toTipsObj'
export default {
  name: 'AuxOutput',
  components: {
    PublicMultipleSelect,
    Output,
    videoModule
  },
  data () {
    return {
      // live source 配置
      LiveParams: '',
      AllConfigParams: '',
      auxOutput: {
        sourceId: '',
        fileName: '',
        output: [],
        outputId: '',
        outputName: '',
        startTime: '',
        endTime: '',
        id: ''
      },
      otherParam: {
        isMultiple: 0
      },
      RegionInfo: '',
      // Program信息
      ProgramItem: {},
      StyleMessage: {
        width: '170px',
        height: '96px'
      },
      liveData: {},
      OutputHistoryList: [],
      PreviewLink: '',
      outputParams: {
        isStart: false,
        time: '00:00:00'
      },
      outputLoading: false,
      occasionalOutputMessageParams: [],
      occasionalOutputMessage: false,
      totalDuration: 0,
      resetOutput: false,
      outputPageParams: {
        pageNum: 1,
        pageSize: 5
      }
    }
  },
  computed: {
    ...mapState({
      pageSerBusRequest: state => state.websocket.pageSerBusRequest,
      CloneDisabled: (state) => state.playout.CloneDisabled,
      pageRWebsocket: (state) => state.websocket.pageRWebsocket
    }),
    durationTime () {
      return Outil.getDuration(this.outputParams.time)
    }
  },
  created () {
    this.outputInfo()
    this.setConfiguration()
    this.getOutputPage()
    this.getTotalTime()
    window.addEventListener('scroll', this.scrollOutput, true)
    // 获取program信息
    this.ProgramItem = Outil.getProgramReceiver()
    Bus.$on('outputPreview', (data) => {
      const dataObj = JSON.parse(JSON.stringify(data))
      dataObj.data.SDI = true
      dataObj.data.WebRSDIFeedUrl = this.PreviewLink
      this.liveData = dataObj.data
    })
  },
  methods: {
    getTotalTime () {
      this.axios({
        method: 'post',
        url: Outil.getUrl('/auxoutput/totalTime'),
        data: {
          programId: Outil.getProgramReceiver().ProgramId
        }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          const result = res.data.result
          if (result) {
            this.totalDuration = result
          } else {
            this.totalDuration = 0
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // 滚动加载
    scrollOutput () {
      const historyListDocument = document.getElementsByClassName('outputHistoryList')[0]
      const historyHeight = historyListDocument.offsetHeight
      const historyScrollHeight = historyListDocument.scrollHeight
      const scrollTop = historyListDocument.pageYOffset || historyListDocument.scrollTop
      if (historyScrollHeight - historyHeight - scrollTop < 10) {
        this.getOutputAllPage()
      }
    },
    // output初始化
    outputInfo () {
      this.axios({
        method: 'post',
        url: Outil.getUrl('/auxoutput/starting/info'),
        data: {
          programId: Outil.getProgramReceiver().ProgramId
        }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          const result = res.data.result
          if (result && result.status) {
            this.PreviewLink = result.appendIx
            this.auxOutput.sourceId = result.sourceId
            this.auxOutput.fileName = result.sourceName
            this.auxOutput.outputId = result.outputId
            this.auxOutput.outputName = result.outputName
            this.auxOutput.id = result.id
            this.auxOutput.output.push({
              outputId: result.outputId,
              outputName: result.outputName
            })
            this.resetOutput = true
            Bus.$emit('outputstart', 1)
            this.SourceWebsocket()
          }
          this.occasionalOutputMessage = true
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // 开始推流
    startOutput () {
      if (!this.auxOutput.sourceId || !this.auxOutput.outputId) {
        this.$message.info(this.$t('lang.selectSourceAndOutput'))
        return
      }
      this.outputLoading = true
      this.auxOutput.startTime = new Date().getTime()
      this.auxOutput.programId = Outil.getProgramReceiver().ProgramId
      this.axios({
        method: 'post',
        url: Outil.getUrl('/auxoutput/start'),
        data: this.auxOutput
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          this.outputLoading = false
          const result = res.data.result
          if (result) {
            this.PreviewLink = result.appendIx
            this.auxOutput.id = result.id
            this.resetOutput = true
            this.outputParams.isStart = true
            // this.ProgramItem = Outil.getProgramReceiver()
            // this.currentSelectData(this.ProgramItem)
            Bus.$emit('outputstart', 1)

            this.SourceWebsocket()
          }
        } else {
          this.outputLoading = false
          console.log(res.data.errorInfo)
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          console.log(errorInfo)
          this.$message.error(errorInfo)
        }
      }).catch(() => {
        this.outputLoading = false
      })
    },
    // 结束推流
    stopOutput () {
      this.outputLoading = true
      this.auxOutput.programId = Outil.getProgramReceiver().ProgramId
      this.auxOutput.endTime = new Date().getTime()
      this.axios({
        method: 'post',
        url: Outil.getUrl('/auxoutput/end'),
        data: this.auxOutput
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          this.outputLoading = false
          this.StopSourceWebsocket()
          this.outputParams.isStart = false
          this.outputPageParams.pageNum = 1
          this.getOutputPage()
          this.getTotalTime()
          Bus.$emit('outputstart', 0)
          this.resetOutput = false
          this.outputParams.time = '00:00:00'
          // this.stop = true
        } else {
          this.outputLoading = false
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {
        this.outputLoading = false
      })
    },
    // 分页查询
    getOutputAllPage () {
      console.log(this.outputPageParams.pageNum)
      if (this.total == this.OutputHistoryList.length || this.total < this.OutputHistoryList.length) return
      this.outputPageParams.pageNum++
      this.getOutputPage()
    },
    // output记录
    getOutputPage () {
      this.outputPageParams.programId = Outil.getProgramReceiver().ProgramId
      this.axios({
        method: 'post',
        url: Outil.getUrl('/auxoutput/page'),
        data: this.outputPageParams
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          const result = res.data.result
          if (result) {
            result.list.forEach(item => {
              item.duration = item.endTime - item.startTime
            })
            if (this.outputPageParams.pageNum == 1) {
              this.OutputHistoryList = result.list
              this.total = result.total
            } else {
              this.OutputHistoryList = this.OutputHistoryList.concat(result.list)
            }
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // 时间
    SourceWebsocket () {
      const ProgramId = Outil.getProgramReceiver().ProgramId
      const urlInfo = JSON.parse(localStorage.getItem('channelInitConfig')).urlInfo
      const { websocketServerName } = urlInfo
      this.StopSourceWebsocket()
      this.pageSerBusRequest.send({
        message: {
          serverName: websocketServerName,
          data: JSON.stringify({
            data: JSON.stringify({
              programId: ProgramId
            }),
            module: 'channelAuxOutputCountDown'
          })
        },
        time: 500,
        key: 'channelAuxOutputCountDown',
        success: res => {
          const result = JSON.parse(res.result.data)
          if (result) {
            this.outputParams.isStart = true
            this.outputParams.time = Outil.getDuration(result.countDown * 1000)
          }
        }
      })
    },
    // 停止Websocket
    StopSourceWebsocket () {
      if (this.$createWebsocket.pageSerBusRequest) {
        this.$createWebsocket.pageSerBusRequest('stop', [
          'channelAuxOutputCountDown'
        ]) // 停止websocket
      }
    },
    // 初始化配置
    setConfiguration () {
      this.RegionInfo = this.$BehaviorSyns.getRegionBucket()
      const programId = this.$BehaviorSyns.getProgramId()
      this.AllConfigParams = SourceConfigParams(programId, this.RegionInfo.bucket)
      this.LiveParams = {
        List: {
          Live: this.AllConfigParams.Live
        },
        search: this.AllConfigParams.search
      }
    },
    // source选择
    SubeventFileDispose (pitchOnFile) {
      this.auxOutput.sourceId = pitchOnFile.peerId || pitchOnFile.sourceId
      this.auxOutput.fileName = pitchOnFile.name
    },
    // 子事件文件信息清除
    SubeventClearMessage () {
      this.auxOutput.sourceId = ''
      this.auxOutput.fileName = ''
      // 推送操作
      this.PushUndo()
    },
    // output选择
    AccountSelectInfo (data) {
      console.log(data)
      const outputArr = JSON.parse(JSON.stringify(data))
      if (outputArr[0]) {
        this.auxOutput.output = JSON.parse(JSON.stringify(outputArr))
        this.auxOutput.outputId = outputArr[0].outputId
        this.auxOutput.outputName = outputArr[0].outputName
      }
    },
    // 展示时间
    displayTime (startTime) {
      const startDate = Outil.getDateTime(new Date(startTime))
      const startDay = `${startDate.year}-${startDate.month}-${startDate.day}`
      return `${startDay} ${startDate.hour}:${startDate.min}:${startDate.s}`
    },
    // 计算分秒小时
    calculateInterval (time) {
      if (typeof time == 'number') {
        let hour = Math.floor(time / (60 * 60 * 1000))
        let minute = Math.floor((time % (60 * 60 * 1000)) / (60 * 1000))
        let second = Math.floor((time % (60 * 1000)) / 1000)
        hour = hour ? `${hour}h` : ''
        minute = minute ? `${minute}m` : ''
        second = second ? `${second}s` : ''
        return hour + minute + second
      } else {
        return ''
      }
    }
  },
  beforeDestroy () {
    Bus.$off('outputPreview')
    window.removeEventListener('scroll', this.scrollOutput)
  }
}
</script>

<style lang="less" scoped>
.AuxOutput{
    padding-top: 12px;
    .output-item{
        margin-bottom: 16px;
        display: flex;
        .title{
            width: 140px;
            line-height: 32px;
            color: #DBDBDB;
            text-align: left;
        }
        ::v-deep .el-select{
             width: 100%;
            .el-input--suffix {
                .el-input__inner {
                    background: #252525;
                    height: 32px;
                    font-size: 12px;
                    color: #dbdbdb;
                    padding-left: 10px;
                    padding-right: 0;
                }
            }
        }

    }
    .video{
        text-align: center;
        .videoBox{
            margin-left: 110px;
        }
        .blackOutput{
          margin-left: 110px;
          background:#252525 ;
        }
    }
    .button{
        margin-top: 16px;
        .el-button{
           width: 100%;
           height: 32px;
           line-height: 0;
        }
    }
    .outputHistoryList {
    margin-top: 11px;
    padding-top: 15px;
    border-top: 2px solid #555555;
    border-bottom: 2px solid #555555;
    height: 170px;
    overflow-y: auto;
    .outputHistory {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      .left {
        text-align: left;
        .name {
          color: #dfdfdf;
        }
        .time {
          color: #888888;
          margin-top: 3px;
        }
      }
      .right {
        color: #dbdbdb;
        span {
          color: #888888;
        }
      }
    }
    }
    .totalDuration{
      text-align: right;
      color: #999999;
    }
}
</style>
